module.exports = __webpack_public_path__ + "yeni ofis 7.jpg?0b5baad28ffb4342f7fa86bf42b0c4a6";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni ofis 7.jpg
// module id = 391
// module chunks = 0